var render, staticRenderFns
import script from "./transition_expand.vue?vue&type=script&lang=js&"
export * from "./transition_expand.vue?vue&type=script&lang=js&"
import style0 from "./transition_expand.vue?vue&type=style&index=0&id=1155a5b0&scoped=true&lang=css&"
import style1 from "./transition_expand.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1155a5b0",
  null
  
)

export default component.exports